import React, {PureComponent} from "react";
import {
	View,
	StyleSheet,
} from "react-native";

import Modal from "./Modal";
import StyledText from "./StyledText";
import StyledButton from "./StyledButton";
import StyledIcon from "./StyledIcon";
import Style from "ae-style";

const styles = StyleSheet.create({
	title: {
		marginBottom: Style.layout.marginLarge
	},
	content: {
		marginVertical: Style.layout.marginLarge,
		alignItems: "center"
	},
	lastAction: {
		marginTop: Style.layout.marginLarge
	},
	icon: {
		marginRight: Style.layout.marginLarge
	}
});

export default class ConfirmationModal extends PureComponent {
	render(){
		const props = this.props;
		const children = props.children;

		const open = props.open;
		const title = props.title;
		const titleIcon = props.titleIcon;

		const confirmText = props.confirmText;
		const cancelText = props.cancelText;

		const onConfirm = props.onConfirm;
		const onCancel = props.onCancel;

		const icon = titleIcon ? (
			<StyledIcon style={styles.icon} smallHeading contrast name={titleIcon} />
	) : null;

		return (
			<Modal open={open}>
				<StyledText testID={props.id} style={styles.title} smallHeading contrast>
					{icon}
					{icon && " "}
					{title}
				</StyledText>
				<View style={styles.content}>
					{children}
				</View>
				<StyledButton testID={props.id + "_confirm"} title={confirmText} icon="check" onPress={onConfirm} />
				<StyledButton testID={props.id + "_cancel"} style={styles.lastAction} alert title={cancelText} icon="delete" onPress={onCancel} />
			</Modal>
		);
	}
}

